import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	// Delete this when cleaning up gic-remove-import-issues-button
	importIssues: {
		id: 'issue-create.modal.create-form.actions-container.import-issues',
		defaultMessage: 'Import issues',
		description: 'Label for import issues button',
	},
});
